export default __webpack_public_path__ + "static/media/gate.c5ad4a51.webp";